/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountSyncHistory {
    getFixupPrototypeFunction() { return ServiceAccountSyncHistory.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountSyncHistory>): ServiceAccountSyncHistory {
        let obj = Object.assign(new ServiceAccountSyncHistory(), model);
        ServiceAccountSyncHistory.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountSyncHistory>): ServiceAccountSyncHistory {
        if (!model) return null;
        return ServiceAccountSyncHistory.newInstance(<ServiceAccountSyncHistory> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountSyncHistory) {
        if (!obj) return;

        models.ServiceAccountSyncHistory.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountSyncHistory): boolean {
        Object.setPrototypeOf(obj, ServiceAccountSyncHistory.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.access_governance) {
            for (let val of this.access_governance) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.access_validation) {
            for (let val of this.access_validation) {
                models.ProgressDetailsForAccessValidation.fixupPrototype(val);
            }
        }
        if (this.advisor_data) {
            for (let val of this.advisor_data) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.application_performance_data) {
            for (let val of this.application_performance_data) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.aws_compute_optimizer_data) {
            for (let val of this.aws_compute_optimizer_data) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.aws_security_hub) {
            for (let val of this.aws_security_hub) {
                models.ProgressDetailsForSecurityHub.fixupPrototype(val);
            }
        }
        if (this.azure_ea_unit_price) {
            for (let val of this.azure_ea_unit_price) {
                models.ProgressDetailsForEaUnitRate.fixupPrototype(val);
            }
        }
        if (this.azure_hub_discount) {
            for (let val of this.azure_hub_discount) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.azure_recommendations_data) {
            for (let val of this.azure_recommendations_data) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.billing_info) {
            for (let val of this.billing_info) {
                models.ProgressDetailsForCostProcessing.fixupPrototype(val);
            }
        }
        if (this.cloud_account_tag) {
            for (let val of this.cloud_account_tag) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.cloudops__activity_assessment) {
            for (let val of this.cloudops__activity_assessment) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.cloudops__ai_prompt_analytics) {
            for (let val of this.cloudops__ai_prompt_analytics) {
                models.ProgressDetailsForAiPromptAnalytics.fixupPrototype(val);
            }
        }
        if (this.cloudops__ai_telemetry) {
            for (let val of this.cloudops__ai_telemetry) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.cloudops__backup) {
            for (let val of this.cloudops__backup) {
                models.ProgressDetailsForBackupData.fixupPrototype(val);
            }
        }
        if (this.cloudops__bigquery_metric) {
            for (let val of this.cloudops__bigquery_metric) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.cloudops__custom_metric) {
            for (let val of this.cloudops__custom_metric) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.cloudops__log_analytics_query) {
            for (let val of this.cloudops__log_analytics_query) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.cloudops__metric) {
            for (let val of this.cloudops__metric) {
                models.ProgressDetailsForMetricData.fixupPrototype(val);
            }
        }
        if (this.cloudops__monitoring_alert_assessment) {
            for (let val of this.cloudops__monitoring_alert_assessment) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.cloudops__patch_management) {
            for (let val of this.cloudops__patch_management) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.cloudops__ssm) {
            for (let val of this.cloudops__ssm) {
                models.ProgressDetailsForSsmData.fixupPrototype(val);
            }
        }
        if (this.credential_validation) {
            for (let val of this.credential_validation) {
                models.ProgressDetailsForCredentialsValidation.fixupPrototype(val);
            }
        }
        if (this.dimension_precompute) {
            for (let val of this.dimension_precompute) {
                models.ProgressDetailsForDimensionPrecompute.fixupPrototype(val);
            }
        }
        if (this.dimension_precompute_for_ai) {
            for (let val of this.dimension_precompute_for_ai) {
                models.ProgressDetailsForDimensionPrecompute.fixupPrototype(val);
            }
        }
        if (this.daily_cost_report) {
            for (let val of this.daily_cost_report) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.finops__ai_caller_attribution) {
            for (let val of this.finops__ai_caller_attribution) {
                models.ProgressDetailsForAiBilling.fixupPrototype(val);
            }
        }
        if (this.finops__assessment_report) {
            for (let val of this.finops__assessment_report) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.finops__budget_data) {
            for (let val of this.finops__budget_data) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.finops__cost_anomaly) {
            for (let val of this.finops__cost_anomaly) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.finops__cost_savings) {
            for (let val of this.finops__cost_savings) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.finops__crp_recommendation) {
            for (let val of this.finops__crp_recommendation) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.finops__enterprise_discount_program) {
            for (let val of this.finops__enterprise_discount_program) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.finops__recommendation_v2) {
            for (let val of this.finops__recommendation_v2) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.finops__ri_ontology_sync) {
            for (let val of this.finops__ri_ontology_sync) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.finops__savings_plans) {
            for (let val of this.finops__savings_plans) {
                models.ProgressDetailsForSavingsPlans.fixupPrototype(val);
            }
        }
        if (this.finops__schedule_recommendation) {
            for (let val of this.finops__schedule_recommendation) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.finops__sp_ontology_sync) {
            for (let val of this.finops__sp_ontology_sync) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.gcp_security_command_center) {
            for (let val of this.gcp_security_command_center) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.governance_configuration) {
            for (let val of this.governance_configuration) {
                models.ProgressDetailsForGovernanceConfiguration.fixupPrototype(val);
            }
        }
        if (this.governance_configuration_validation) {
            for (let val of this.governance_configuration_validation) {
                models.ProgressDetailsForGovernanceConfiguration.fixupPrototype(val);
            }
        }
        if (this.governance_report) {
            for (let val of this.governance_report) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.hierarchy_data) {
            for (let val of this.hierarchy_data) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.inventory_data) {
            for (let val of this.inventory_data) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.inventory_data__dashboard_sync) {
            for (let val of this.inventory_data__dashboard_sync) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.inventory_data__dependency_sync) {
            for (let val of this.inventory_data__dependency_sync) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.inventory_data__lock_sync) {
            for (let val of this.inventory_data__lock_sync) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.inventory_data__relationship_sync) {
            for (let val of this.inventory_data__relationship_sync) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.inventory_report) {
            for (let val of this.inventory_report) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.kubernetes_cluster_agent_sync_job) {
            for (let val of this.kubernetes_cluster_agent_sync_job) {
                models.ProgressDetailsForKubernetesAgentSyncStatus.fixupPrototype(val);
            }
        }
        if (this.kubernetes_cluster_agent_health) {
            for (let val of this.kubernetes_cluster_agent_health) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.metric_utilization_data) {
            for (let val of this.metric_utilization_data) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.monthly_cost_report) {
            for (let val of this.monthly_cost_report) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.network_data) {
            for (let val of this.network_data) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.proactive_scanner) {
            for (let val of this.proactive_scanner) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.recovery_data) {
            for (let val of this.recovery_data) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.reserved_instances_recommendation) {
            for (let val of this.reserved_instances_recommendation) {
                models.ProgressDetailsForReservedInstances.fixupPrototype(val);
            }
        }
        if (this.reserved_instances_utilization) {
            for (let val of this.reserved_instances_utilization) {
                models.ProgressDetailsForReservedInstances.fixupPrototype(val);
            }
        }
        if (this.secure_score_data) {
            for (let val of this.secure_score_data) {
                models.ProgressDetailsForSecureScore.fixupPrototype(val);
            }
        }
        if (this.security__azure_sentinel) {
            for (let val of this.security__azure_sentinel) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.security__tenable_nessus) {
            for (let val of this.security__tenable_nessus) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.servicenow_cmdb_sync_job) {
            for (let val of this.servicenow_cmdb_sync_job) {
                models.ProgressDetailsForServiceNowCmdbSync.fixupPrototype(val);
            }
        }
        if (this.system_policy_execution) {
            for (let val of this.system_policy_execution) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.threat_data) {
            for (let val of this.threat_data) {
                models.ProgressDetailsForThreat.fixupPrototype(val);
            }
        }
        if (this.utilization_metrics_data) {
            for (let val of this.utilization_metrics_data) {
                models.ProgressDetails.fixupPrototype(val);
            }
        }
        if (this.vulnerability_data) {
            for (let val of this.vulnerability_data) {
                models.ProgressDetailsForVulnerability.fixupPrototype(val);
            }
        }
        if (this.wellarchitected__auto_assessment) {
            for (let val of this.wellarchitected__auto_assessment) {
                models.ProgressDetailsForWellArchitectedAutoAssessment.fixupPrototype(val);
            }
        }
    }

    /**
     * Access Governance status history
     */
    access_governance: Array<models.ProgressDetails>;

    /**
     * Access Validation status history
     */
    access_validation: Array<models.ProgressDetailsForAccessValidation>;

    /**
     * Advisor Data status history
     */
    advisor_data: Array<models.ProgressDetails>;

    /**
     * Application Performance data status history
     */
    application_performance_data: Array<models.ProgressDetails>;

    /**
     * AWS Compute Optimizer Data status history
     */
    aws_compute_optimizer_data: Array<models.ProgressDetails>;

    /**
     * AWS Security Hub Sync Details status history
     */
    aws_security_hub: Array<models.ProgressDetailsForSecurityHub>;

    /**
     * Azure EA Unit Price Data status history
     */
    azure_ea_unit_price: Array<models.ProgressDetailsForEaUnitRate>;

    /**
     * Azure Hub Discount Details status history
     */
    azure_hub_discount: Array<models.ProgressDetails>;

    /**
     * Azure Recommendations Data status history
     */
    azure_recommendations_data: Array<models.ProgressDetails>;

    /**
     * Billing Info status history
     */
    billing_info: Array<models.ProgressDetailsForCostProcessing>;

    /**
     * Cloud Account Tag Sync status history
     */
    cloud_account_tag: Array<models.ProgressDetails>;

    /**
     * Activity Assessment Data status history
     */
    cloudops__activity_assessment: Array<models.ProgressDetails>;

    /**
     * AI Prompt Analytics status history
     */
    cloudops__ai_prompt_analytics: Array<models.ProgressDetailsForAiPromptAnalytics>;

    /**
     * AI Telemetry status history
     */
    cloudops__ai_telemetry: Array<models.ProgressDetails>;

    /**
     * Backup Data status history
     */
    cloudops__backup: Array<models.ProgressDetailsForBackupData>;

    /**
     * BigQuery Metric Data status history
     */
    cloudops__bigquery_metric: Array<models.ProgressDetails>;

    /**
     * Custom Metric Data status history
     */
    cloudops__custom_metric: Array<models.ProgressDetails>;

    /**
     * Log Analytics Query Data status history
     */
    cloudops__log_analytics_query: Array<models.ProgressDetails>;

    /**
     * Metric Data status history
     */
    cloudops__metric: Array<models.ProgressDetailsForMetricData>;

    /**
     * Monitoring Alert Assessment Data status history
     */
    cloudops__monitoring_alert_assessment: Array<models.ProgressDetails>;

    /**
     * Patch Management Data status history
     */
    cloudops__patch_management: Array<models.ProgressDetails>;

    /**
     * SSM Data status history
     */
    cloudops__ssm: Array<models.ProgressDetailsForSsmData>;

    /**
     * Credential Check Info status history
     */
    credential_validation: Array<models.ProgressDetailsForCredentialsValidation>;

    /**
     * Dimension Precompute status history
     */
    dimension_precompute: Array<models.ProgressDetailsForDimensionPrecompute>;

    /**
     * Dimension Precompute for AI status history
     */
    dimension_precompute_for_ai: Array<models.ProgressDetailsForDimensionPrecompute>;

    /**
     * Daily Cost Report status history
     */
    daily_cost_report: Array<models.ProgressDetails>;

    /**
     * AI Caller Attribution status history
     */
    finops__ai_caller_attribution: Array<models.ProgressDetailsForAiBilling>;

    /**
     * Finops Assessment Report status history
     */
    finops__assessment_report: Array<models.ProgressDetails>;

    /**
     * Budget Data status history
     */
    finops__budget_data: Array<models.ProgressDetails>;

    /**
     * Cost Anomaly status history
     */
    finops__cost_anomaly: Array<models.ProgressDetails>;

    /**
     * Schedule Recommendation Cost Savings status history
     */
    finops__cost_savings: Array<models.ProgressDetails>;

    /**
     * CRP Recommendation status history
     */
    finops__crp_recommendation: Array<models.ProgressDetails>;

    /**
     * Enterprise Discount Program status history
     */
    finops__enterprise_discount_program: Array<models.ProgressDetails>;

    /**
     * Finops Recommendations V2 status history
     */
    finops__recommendation_v2: Array<models.ProgressDetails>;

    /**
     * Billing & Cost Analytics — RI ontology projection into GraphDB status history
     */
    finops__ri_ontology_sync: Array<models.ProgressDetails>;

    /**
     * Savings Plans status history
     */
    finops__savings_plans: Array<models.ProgressDetailsForSavingsPlans>;

    /**
     * Schedule Recommendation status history
     */
    finops__schedule_recommendation: Array<models.ProgressDetails>;

    /**
     * Billing & Cost Analytics — SP ontology projection into GraphDB status history
     */
    finops__sp_ontology_sync: Array<models.ProgressDetails>;

    /**
     * GCP Security Command Center Data status history
     */
    gcp_security_command_center: Array<models.ProgressDetails>;

    /**
     * Application of Governance Configurations status history
     */
    governance_configuration: Array<models.ProgressDetailsForGovernanceConfiguration>;

    /**
     * Validation of Governance Configurations status history
     */
    governance_configuration_validation: Array<models.ProgressDetailsForGovernanceConfiguration>;

    /**
     * Governance Report status history
     */
    governance_report: Array<models.ProgressDetails>;

    /**
     * Service Account Hierarchy status history
     */
    hierarchy_data: Array<models.ProgressDetails>;

    /**
     * Inventory Data status history
     */
    inventory_data: Array<models.ProgressDetails>;

    /**
     * Inventory Dashboard Data Sync status history
     */
    inventory_data__dashboard_sync: Array<models.ProgressDetails>;

    /**
     * Inventory Dependency Data Sync status history
     */
    inventory_data__dependency_sync: Array<models.ProgressDetails>;

    /**
     * Inventory Lock Data Sync status history
     */
    inventory_data__lock_sync: Array<models.ProgressDetails>;

    /**
     * Inventory Relationship Data Sync status history
     */
    inventory_data__relationship_sync: Array<models.ProgressDetails>;

    /**
     * Inventory Report status history
     */
    inventory_report: Array<models.ProgressDetails>;

    /**
     * Kubernetes Agent Sync Job Data status history
     */
    kubernetes_cluster_agent_sync_job: Array<models.ProgressDetailsForKubernetesAgentSyncStatus>;

    /**
     * Kubernetes Agent Health status history
     */
    kubernetes_cluster_agent_health: Array<models.ProgressDetails>;

    /**
     * Utilization Dashboard Metric Sync status history
     */
    metric_utilization_data: Array<models.ProgressDetails>;

    /**
     * Monthly Cost Report status history
     */
    monthly_cost_report: Array<models.ProgressDetails>;

    /**
     * Network Data status history
     */
    network_data: Array<models.ProgressDetails>;

    /**
     * ProActive Scanner status history
     */
    proactive_scanner: Array<models.ProgressDetails>;

    /**
     * Recovery Data status history
     */
    recovery_data: Array<models.ProgressDetails>;

    /**
     * Reserved Instance Recommendations status history
     */
    reserved_instances_recommendation: Array<models.ProgressDetailsForReservedInstances>;

    /**
     * Reserved Instance utilization status history
     */
    reserved_instances_utilization: Array<models.ProgressDetailsForReservedInstances>;

    /**
     * Secure Score Data status history
     */
    secure_score_data: Array<models.ProgressDetailsForSecureScore>;

    /**
     * Azure Sentinel Data Collection status history
     */
    security__azure_sentinel: Array<models.ProgressDetails>;

    /**
     * Tenable Nessus Vulnerability Data status history
     */
    security__tenable_nessus: Array<models.ProgressDetails>;

    /**
     * ServiceNow CMDB Sync Job Data status history
     */
    servicenow_cmdb_sync_job: Array<models.ProgressDetailsForServiceNowCmdbSync>;

    /**
     * System Policy Execution Data status history
     */
    system_policy_execution: Array<models.ProgressDetails>;

    /**
     * Threat Data status history
     */
    threat_data: Array<models.ProgressDetailsForThreat>;

    /**
     * Utilization Metrics Dashboard for Metric Sync status history
     */
    utilization_metrics_data: Array<models.ProgressDetails>;

    /**
     * Vulnerability Data status history
     */
    vulnerability_data: Array<models.ProgressDetailsForVulnerability>;

    /**
     * WellArchitected Auto Assessment Details status history
     */
    wellarchitected__auto_assessment: Array<models.ProgressDetailsForWellArchitectedAutoAssessment>;

}
